import { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import "../styles/assetDetails.css";

import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]); 

const getAlignmentStyle = (params) => {
  const value = params?.value;

  // actual numbers
  if (typeof value === "number") {
    return { textAlign: "right" };
  }

  // numeric strings like:
  // "25%", "-10.5", "1,245.88", etc.
  if (typeof value === "string") {
    const numericValue = Number(
      value
        .replace("%", "")
        .replace(/,/g, "")
        .trim()
    );

    const isValidNumber = !isNaN(numericValue);

    if (isValidNumber) {
      return { textAlign: "right" };
    }

    return { textAlign: "left" };
  }

  return null;
};

const AssetSummaryGrid = ({ data }) => {

  const columnDefs = useMemo(() => [
    {
      headerName: "",
      field: "strategyName",
      flex: 2,
      minWidth: 320,
      cellRenderer: (params) => {
        const color = params.data?.colorCode;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {color && (
              <div
                style={{
                  width: 16,
                  height: 16,
                  backgroundColor: /^#([0-9A-Fa-f]{3}){1,2}$/.test(color) ? color : "transparent"
                }}
              />
            )}
            <span>{params.value}</span>
          </div>
        );
      },
      cellStyle: (params) =>
      {
        const alignmentStyle = getAlignmentStyle(params)
        return params.data?.isTotalPortfolio
          ? { fontWeight: "bold", backgroundColor: "#E6E3F0", ...alignmentStyle }
          : alignmentStyle
      }
    },
    {
      headerName: "Market Value",
      headerClass: "ag-right-header",
      field: "endingBalanceSubStrategyLevel",
      valueFormatter: (params) =>
        params.value != null
          ? params.value.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0
            })
          : "",
      cellStyle: (params) =>
        {
        const alignmentStyle = getAlignmentStyle(params)
        return params.data?.isTotalPortfolio
          ? { fontWeight: "bold", backgroundColor: "#E6E3F0", ...alignmentStyle }
          : alignmentStyle
      }
    },
    {
      headerName: "Percentage",
      headerClass: "ag-right-header",
      field: "percentage",
      valueFormatter: (params) =>
        params.value != null
          ? `${(params.value * 100).toFixed(2)} %`
          : "",
      cellStyle: (params) =>
        {
        const alignmentStyle = getAlignmentStyle(params)
        return params.data?.isTotalPortfolio
          ? { fontWeight: "bold", backgroundColor: "#E6E3F0", ...alignmentStyle }
          : alignmentStyle
      }
    }
  ], []);

  if (!data || data.length === 0) {
    return <div>No Data</div>;
  }

  return (
    <div className="ag-theme-alpine" style={{ width: "100%" }}>
      <AgGridReact
        theme={"legacy"}
        rowData={data}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        getRowStyle={(params) => {
            if (params.data?.isTotalPortfolio) {
              return {
                backgroundColor: "#E6E3F0",
                fontWeight: "bold"
              };
            }

            return {
              backgroundColor: "#FFFFFF"
            };
          }}
         defaultColDef={{
            flex: 1,
            minWidth: 100,
            resizable: false,
            suppressHeaderMenuButton: true,
  suppressHeaderContextMenu: true
          }}
      />
    </div>
  );
};

export default AssetSummaryGrid;